import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import SmallBusinessHero from './components/SmallBusinessHero';
import SmallBusinessPainPoints from './components/SmallBusinessPainPoints';
import SmallBusinessHowHelps from './components/SmallBusinessHowHelps';
import SmallBusinessExamples from './components/SmallBusinessExamples';
import SmallBusinessHowItWorks from './components/SmallBusinessHowItWorks';
import SmallBusinessBenefits from './components/SmallBusinessBenefits';
import SmallBusinessFAQ from './components/SmallBusinessFAQ';
import SmallBusinessCTA from './components/SmallBusinessCTA';

export default function SmallBusinessPage() {
  return (
    <>
      <title>AI Ads for Small Business | Get More Customers with Small Business Advertising | AdForge</title>
      <meta
        name="description"
        content="AI ads for small business that actually get customers. AdForge creates Facebook ads for small business, Google ads, and Instagram ads in minutes. No marketing experience needed. Try free."
      />
      <meta
        name="keywords"
        content="AI ads for small business, small business advertising, facebook ads for small business, google ads for small business, local business marketing, small business ad generator"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ads-for-small-business" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ads for Small Business | AdForge — Get More Customers" />
      <meta
        property="og:description"
        content="AI-powered small business advertising that gets real customers. Build Facebook ads, Google ads, and more in minutes. No experience needed."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ads-for-small-business" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ads for Small Business | AdForge" />
      <meta
        name="twitter:description"
        content="Stop wasting money on ads that don't work. AdForge builds AI ads for small business in minutes. Free to start."
      />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ads for Small Business — AdForge',
        description:
          'AdForge creates AI ads for small businesses including retail shops, restaurants, salons, gyms, and service businesses. Generate Facebook ads and Google ads in minutes.',
        url: 'https://adforge.ai/ai-ads-for-small-business',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator for Small Business',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '2180',
          },
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Do I need marketing experience to use AI ads for small business?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No. AdForge is built for business owners with zero marketing experience. You answer a few simple questions about your business and the AI does the rest — writing the copy, generating images, and formatting ads for Facebook, Instagram, and Google.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much do Facebook ads for small business cost with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge is free to start. Paid plans start at $29/month. Your actual Facebook ad spend is separate and set by you directly in Facebook Ads Manager.',
            },
          },
          {
            '@type': 'Question',
            name: 'What types of small businesses can use AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge works for virtually any small business: retail shops, restaurants, cafes, salons, gyms, law firms, dental offices, real estate agents, e-commerce stores, and more.',
            },
          },
          {
            '@type': 'Question',
            name: 'How fast can I create small business advertising with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most business owners generate their first complete ad package — including copy, headlines, hooks, and AI images — in under 3 minutes.',
            },
          },
          {
            '@type': 'Question',
            name: 'Does AdForge create Google ads for small businesses too?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. AdForge generates ad copy optimized for Facebook, Instagram, Google Ads, TikTok, and LinkedIn. You get platform-specific formatting for each.',
            },
          },
        ],
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <SmallBusinessHero />
          <SmallBusinessPainPoints />
          <SmallBusinessHowHelps />
          <SmallBusinessExamples />
          <SmallBusinessHowItWorks />
          <SmallBusinessBenefits />
          <SmallBusinessFAQ />
          <SmallBusinessCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
